import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { dashboardUri } from 'Consts/clientUris';
import paths from 'paths';

// TODO: remove this, adjust old pages to use page context and be resource-driven
export default function dashboardOrOnboarding(clientOrHouseholdResource) {
  // Includes search so that ?t= could be included.
  // For example, if you took a while to perform an action, we don't want you to get logged out, especially since the next page could be where you set your password - so keep ?t= so that you can be logged in again if you were logged out.
  const search = `?${new URLSearchParams(window.location.search)}`;
  return pick(clientOrHouseholdResource, {
    [fr.relationships.nextOnboardingStep.name]: `${paths.welcomeSurvey}${search}`,
    [fr.relationships.hasDigitalOnboarding.name]: `${paths.welcomeSurvey}${search}`,
  }, `${dashboardUri}${search}`);
}
